import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert2';
import axios from 'axios';
import API from '../middleware/API';

const HRDocuments = ({ userId,realName, storeId, isShow, toggleFunc }) => {
    const [documents, setDocuments] = useState({ type1Documents: [], type2Documents: [], type3Documents: [] });
  
    useEffect(() => {
      if (isShow) {
        API.get(`/User/Documents/${userId}`).then((response) => {
          if (response) {
            setDocuments(response);
          } else {
            console.error('Failed to fetch documents:', response.data.message);
          }
        });
      }
    }, [isShow, userId, realName]);
  

    const generateEmpLeaveExcel = () => {
            axios({
          url:process.env.REACT_APP_NODE_ENV === 'development'?
          'https://www.liangshishu.link:46890/api/User/'+userId+'/LeaveDoc':
          'https://www.liangshishu.link:46888/api/User/'+userId+'/LeaveDoc',
          method: 'GET',
          headers:{
    'Authorization': 'bearer ' + localStorage.getItem('access_token'),
      'StoreId':storeId },
      responseType: 'blob'}).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', realName+'離職證明書.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
          }).catch((error) => {
        swal.fire({
          type: 'error',
          title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
          heightAuto: false,
        });
      });
      }
     const generateEmpInfoExcel = () => {
        axios({
          url:process.env.REACT_APP_NODE_ENV === 'development'?
          'https://www.liangshishu.link:46890/api/User/'+userId+'/Excel':
          'https://www.liangshishu.link:46888/api/User/'+userId+'/Excel',
          method: 'GET',
          headers:{
    'Authorization': 'bearer ' + localStorage.getItem('access_token'),
      'StoreId':storeId },
      responseType: 'blob'}).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', realName+'員工資料卡.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
          }).catch((error) => {
        swal.fire({
          type: 'error',
          title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
          heightAuto: false,
        });
      });
    
      }


    const handleUpload = (file, typeName) => {
      const formData = new FormData();
      formData.append('PicFile', file);
  
      axios
        .post('https://wisdombank-dev.liangshishu.com/member/api/FileUploader/CafeDocument', formData)
        .then((uploadResponse) => {
          const uploadedFileName = uploadResponse.data.split('/')[uploadResponse.data.split('/').length-1];
  
          API
            .post(`/User/Documents/${userId}`, null, {
              params: { typeName, fileName: uploadedFileName },
            })
            .then(() => {
              swal.fire('完成上傳', '檔案上傳成功', 'success');
              // Refresh the document list
              API.get(`/User/Documents/${userId}`).then((response) => {
                if (response) {
                  setDocuments(response);
                } else {
                  console.error('Failed to fetch documents:', response.data.message);
                }
              });
            })
            .catch((error) => {
              console.error('Failed to update document:', error);
              swal.fire('發生錯誤', '檔案上傳失敗', 'error');
            });
        })
        .catch((error) => {
          console.error('File upload failed:', error);
          swal.fire('發生錯誤', '檔案上傳失敗', 'error');
        });
    };
  
    const renderDocuments = (documents, typeName) => {
      return documents.map((doc) => (
        <div key={doc.typeName} style={{ marginBottom: '10px' }}>
          <span>{doc.typeName}</span> <br />
          {doc.isSubmitted ? (
            <>
              <button
                className="btn btn-md success m-l-8"
                onClick={() => {
                  axios
                    .get(`https://s3-ap-northeast-1.amazonaws.com/questionbank-resource/CafeDocument/${doc.fileName}`, {
                      responseType: 'blob', // Fetch the file as a blob
                    })
                    .then((response) => {
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', `${doc.fileName}.pdf`); // Set the file name
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    })
                    .catch((error) => {
                      console.error('Failed to download file:', error);
                      swal.fire('錯誤', '下載失敗', 'error');
                    });
                }}
                style={{ marginLeft: '10px' }}
              >
                下載
              </button>
              <button
                className="btn btn-md edit m-l-8"
                onClick={() => {
                  swal
                    .fire({
                      title: '確認刪除？',
                      text: `確定要刪除 ${doc.typeName} 嗎？`,
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonText: '是',
                      cancelButtonText: '否',
                    })
                    .then((result) => {
                      if (result.value) {
                        API.delete(`/User/Documents/${userId}`, {
                          params: { fileName: doc.fileName },
                        })
                          .then(() => {
                            swal.fire('完成', '檔案已刪除', 'success');
                            // Refresh the document list
                            API.get(`/User/Documents/${userId}`).then((response) => {
                              if (response) {
                                setDocuments(response);
                              } else {
                                console.error('Failed to fetch documents:', response.data.message);
                              }
                            });
                          })
                          .catch((error) => {
                            console.error('Failed to delete document:', error);
                            swal.fire('錯誤', '檔案刪除失敗', 'error');
                          });
                      }
                    });
                }}
                style={{ marginLeft: '10px' }}
              >
                刪除
              </button>
              <input
                type="file"
                accept=".pdf" // 限制只能選擇 PDF 檔案
                onChange={(e) => {
                  handleUpload(e.target.files[0], doc.typeName);
                  e.target.value = ''; // Clear the file input after upload
                }}
                style={{ marginLeft: '10px' }}
              />
            </>
          ) : (
            <input
              type="file"
              accept=".pdf" // 限制只能選擇 PDF 檔案
              onChange={(e) => {
                handleUpload(e.target.files[0], doc.typeName);
                e.target.value = ''; // Clear the file input after upload
              }}
              style={{ marginLeft: '10px' }}
            />
          )}
        </div>
      ));
    };
    
    return (
        <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
      <div
        className="form-block"
        style={{
        display: isShow === true ? 'flex' : 'none',
        backgroundColor: 'white', padding: '20px', borderRadius: '10px', height: 'auto'
        }}
      >
        <div className="u-form">
          <div className="row" style={{ width: '100%' }}>
        <div className="hr-documents-block col-6 col-pad-12">
          <div className="u-small-title">到職相關</div>
          {renderDocuments(documents.type1Documents, 'type1Documents')}
        </div>
        <div className="hr-documents-block col-6 col-pad-12">

        <div className="hr-documents-block col-12 col-pad-12">
          <div className="u-small-title">離職相關</div>
          {renderDocuments(documents.type2Documents, 'type2Documents')}
          
        </div>
        <div className="hr-documents-block col-12 col-pad-12">
          <div className="u-small-title">其他</div>
          {renderDocuments(documents.type3Documents, 'type3Documents')}
                    <a
            style={{width:'160px'}}

            href="/"
            className="btn btn-md main-color"
            onClick={(e) => {
              e.preventDefault();
              generateEmpInfoExcel();
            }}
          >
            下載員工資料表
          </a>
          <br/>
          <a
            style={{width:'160px'}}
            href="/"
            className="btn btn-md main-color"
            onClick={(e) => {
              e.preventDefault();
              generateEmpLeaveExcel();
            }}
          >
            下載離職證明書
          </a>
        </div>
        <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>關閉</button>

            <br />
            <span style={{ fontSize: '16px', color: 'red' }}>
              * 檔案上傳限制為 PDF 格式</span>
        </div>
        </div>
        </div>
        
        </div>
        </div>
    );
  };

export default HRDocuments;